import { getValidationResult } from './index';

const PROJECT = {
	KEY_MIN_LENGTH: 2,
	KEY_MAX_LENGTH: 50,
	NAME_MIN_LENGTH: 3,
	NAME_MAX_LENGTH: 120
};

const ERROR_MESSAGES = {
	PROJECT: {
		KEY: `شناسه باید بیشتر از ${PROJECT.KEY_MIN_LENGTH}
		 و کمتر از ${PROJECT.KEY_MAX_LENGTH} کاراکتر باشد`,
		KEY_REQUIRED: 'شناسه اجباری می باشد',
		NAME: `نام پروژه باید بیشتر از ${PROJECT.NAME_MIN_LENGTH} وکمتر از ${PROJECT.NAME_MAX_LENGTH} کاراکتر باشد`,
		NAME_REQUIRED: 'نام پروژه اجباری می باشد'
	}
};

export const validateName = ({ Name }) => {
	if (!Name) {
		return getValidationResult(false, ERROR_MESSAGES.PROJECT.NAME_REQUIRED);
	}

	const isValid = Name.length >= PROJECT.NAME_MIN_LENGTH && Name.length <= PROJECT.NAME_MAX_LENGTH;
	return getValidationResult(isValid, ERROR_MESSAGES.PROJECT.NAME);
};

export const validateKey = ({ Key }) => {
	if (!Key) {
		return getValidationResult(false, ERROR_MESSAGES.PROJECT.KEY_REQUIRED);
	}

	const isValid = Key.length >= PROJECT.KEY_MIN_LENGTH && Key.length <= PROJECT.KEY_MAX_LENGTH;
	return getValidationResult(isValid, ERROR_MESSAGES.PROJECT.KEY);
};
